import { cacheDom } from '../utils/QuerySelectors.js'
import { addLineItems } from '../utils/Cart.js'

const dom = {}
const qs = {
  atc: 'data-quickadd-cart',
  selected: 'data-product-quickadd-selected',
}
const qsAll = {
  wrappers: 'data-product-quickadd',
  values: 'data-variant-id',
  lists: 'data-quickadd-list',
}

const state = {
  container: null,
  activeClasses: ['product-card--quickadd__active', 'bg-button', 'text-white'],
}

const initQuickAdd = (wrapper) => {
  const atc = wrapper.querySelector(`[${qs.atc}]`)
  const values = wrapper.querySelectorAll(`[${qsAll.values}]`)
  const summary = wrapper.querySelector(`[${qs.selected}]`)
  const details = wrapper.querySelector('details')
  let selectedVariant = Array.from(values)
    .filter((btn) => btn.classList.contains('product-card--quickadd__active'))[0]
    ?.getAttribute(`${qsAll.values}`)
  values.forEach((btn) => {
    btn.addEventListener('click', () => {
      values.forEach((v) => state.activeClasses.forEach((activeClass) => v.classList.toggle(activeClass, v == btn)))
      selectedVariant = btn.getAttribute(`${qsAll.values}`)

      Shopify.analytics.publish('gtm_select_size', {
        product_id: btn.dataset.productId,
        variant_id: selectedVariant,
        item_name: btn.dataset.productName,
        size: btn.dataset.size
      });

      if(summary) {
        summary.innerHTML = btn.innerHTML
        details.removeAttribute('open')
        atc.classList.add('button--primary')
      }
    })
  })
  atc.addEventListener('click', (e) => {
    if (selectedVariant) {
      e.target.setAttribute('disabled', '')

      const properties = typeof window.privateSale != 'undefined' && window.privateSale && atc.getAttribute('data-private') == 'true' ? { '_discount reason': window.privateSaleReason } : {}
      if(atc.getAttribute('data-fragrance') == 'true') properties['_fragrance'] = 'true'
      if (atc.getAttribute('data-preorder') == 'true') properties['_is_preorder'] = 'true'
      if (atc.getAttribute('data-preorder-start-date') != null) properties['_preorder_start_date'] = atc.getAttribute('data-preorder-start-date')
      if (atc.getAttribute('data-preorder-end-date') != null) properties['_preorder_end_date'] = atc.getAttribute('data-preorder-end-date')
      if (atc.getAttribute('data-preorder-customer-group') != null)  properties['_preorder_customer_group'] = atc.getAttribute('data-preorder-customer-group')

      // Public sale info
      const variantObj = atc.getAttribute('data-variant-obj') ? JSON.parse(atc.getAttribute('data-variant-obj')) : null;
      if(variantObj  && variantObj.compare_at_price && variantObj.compare_at_price > variantObj.price) {
        properties['_isPublicSale'] = true
        properties['_originalPrice'] = variantObj.compare_at_price / 100.0
        properties['_discountAmount'] = (variantObj.compare_at_price - variantObj.price) / 100.0
        properties['_discountPercent'] = Math.round(((variantObj.compare_at_price - variantObj.price) / variantObj.compare_at_price) * 100)
      }


      addLineItems(
        (cart) => {
          initMiniCart(cart)
          window.openCart()
        },
        [{ id: selectedVariant, quantity: 1, properties }],
        e.target,
      )
    }
  })
  wrapper.querySelector('summary')?.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  window.addEventListener('click', () => {
    wrapper.querySelectorAll('details').forEach((detail) => detail.removeAttribute('open'))
  })
  values.forEach((v) => {
    const euSize = v.querySelector('[data-eu-size]')
    const size = v.dataset.size
    if (window.sizeMapper[size] && euSize) euSize.innerHTML = window.sizeMapper[size]
  })
}


export const setupQuickAdds = (container = null) => {
  state.container = container
  cacheDom(dom, qs, qsAll, true, state.container)
  dom.wrappers.forEach((wrapper) => initQuickAdd(wrapper))
  dom.lists.forEach((list) => {
    list.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })
}

window.setupQuickAdds = setupQuickAdds
